import { atom } from 'jotai';
import type { Referrer } from '@/components/Approval/@components/ReferrerField';
import type { ApprovalLineInput } from '@/utils/approval/approvalFormToCreatePayload';
import type { AiDraftSectionApi } from '@/components/LexicalEditor/plugins/AiDraftSectionPlugin';
import type { ExpenseVoucherInvalidField } from '@/utils/approval/expenseVoucher';

/**
 * 결재 작성 폼의 참조인 상태 — ReferrerSection과 ApprovalLineSection(최근 결재라인
 * 적용 시 통째 덮어쓰기)이 공유하는 단일 진실원.
 */
export const approvalCreateReferrersAtom = atom<Referrer[]>([]);

/**
 * 결재라인 페이로드 스냅샷. flow는 UI 전용 자료구조를 포함하므로
 * 변환 결과만 atom으로 공유 — CreateFooter가 저장 시 그대로 사용.
 */
export const approvalCreateApprovalLineAtom = atom<ApprovalLineInput>({
  approvers: [],
});

/**
 * 결재라인(협조 포함)에 남은 퇴사자 이름 목록.
 * ApprovalLineSection이 배지와 같은 판정으로 계산, CreateFooter가 상신 차단에 사용.
 */
export const approvalCreateDeactivatedNamesAtom = atom<string[]>([]);

/**
 * 계약 품의 AI 초안 섹션 에디터 API — ContentField 안 플러그인이 mount 때 등록, unmount 때 null.
 * ContractLinkField 가 계약 등록·삭제 시 본문 섹션을 갈아끼우는 통로. 에디터가 늦게 뜨는 동안의
 * 요청은 호출부가 보류 후 재적용
 */
export const contractDraftEditorApiAtom = atom<AiDraftSectionApi | null>(null);

/**
 * AI 업로더가 올리는 중인 파일 — 첨부 목록에 업로드 중 임시 항목으로 보임(레거시 동일).
 * 업로드가 끝나면(성공·실패·취소) 빠지고, 성공분은 attachments 에 들어감
 */
export const approvalCreateUploadingAttachmentsAtom = atom<
  { id: string; fileName: string }[]
>([]);

/** 지출결의서(111) 상신 검사에서 걸린 입력칸 — CreateFooter 가 켜고, 값이 바뀌면 필드가 끔 */
export const expenseVoucherInvalidFieldsAtom = atom<
  ExpenseVoucherInvalidField[]
>([]);
